/* UNSCRIPTED 60-second recall test: cart panel. After the claim (and the digital add-on popups) the visitor sees their cart here,
   then presses Checkout. This layout has no theme cart drawer, so the claim snippet (snippets/unscripted-free-offer) calls window.UmQuizCart.open().
   LAYOUT (phone): cart items get the most room; the bottom area is short and scrolls: express-checkout buttons (Apple Pay, Google Pay, PayPal, Shop Pay, in
   that order) then the notes; "Continue to checkout" stays pinned under the scroll area so it is always visible.
   VISIBLE AREA: on iPhone (Chrome and Safari) fixed elements are laid out against the area behind the browser's bottom bar, so anything pinned to the bottom
   (this panel's Continue button, the claim popups' buttons, the sticky claim bar) was cut off. fit() below writes the height of the area the visitor can really
   see (visualViewport.height) into the CSS variable --vvh, and unscripted-recall-d.css sizes those fixed elements with it. Keep using --vvh, not 100vh or bottom:0.
   Shows free lines as "Free", a subtotal only when something paid was added, and reminds the visitor which email to use at checkout (the quiz email).
   The email is also sent as checkout[email] (brackets unencoded) as a best effort: Shopify did not always apply it in testing, so the copy never promises it.
   EXPRESS CHECKOUT: the theme drawer gets the buttons from Shopify's accelerated-checkout component. This page has no theme drawer, so the panel fetches the
   cart-drawer section HTML (without an Accept: application/json header, or Shopify leaves the wallets out), copies the ".cart__dynamic-checkout-buttons" block
   into #qcwallets and, if Shopify's wallet script did not start by itself, loads portable-wallets. The block includes Shopify's own subscription consent line
   for the coach trial.
   WALLET ORDER: Shopify renders the buttons in the order of the component's wallet-configs attribute (a JSON list). The panel re-sorts that list before the
   HTML is inserted (WALLET_ORDER below). Changing CSS "order" does not work: the component sizes and places the buttons itself. Wallets not in the list keep
   their place after the listed ones. */
(function () {
  var panel = null, lastFocus = null, walletScript = false;
  var WALLET_ORDER = ["apple_pay", "google_pay", "paypal", "shop_pay"];
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function money(cur, cents) { try { return new Intl.NumberFormat(undefined, { style: "currency", currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); } }
  function ev(name, data) { try { if (typeof track === "function") track(name, data || {}); } catch (e) {} }
  function quizEmail() { try { return sessionStorage.getItem("um_quiz_email") || ""; } catch (e) { return ""; } }

  function fit() {
    var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    document.documentElement.style.setProperty("--vvh", Math.round(h) + "px");
  }
  fit();
  window.addEventListener("resize", fit);
  window.addEventListener("orientationchange", fit);
  if (window.visualViewport) { window.visualViewport.addEventListener("resize", fit); window.visualViewport.addEventListener("scroll", fit); }

  function build() {
    panel = document.createElement("div");
    panel.className = "qcart"; panel.hidden = true;
    panel.setAttribute("role", "dialog"); panel.setAttribute("aria-modal", "true"); panel.setAttribute("aria-label", "Your cart");
    panel.innerHTML = '<div class="qcart__box"><div class="qcart__head"><h2>Your cart</h2><button type="button" class="qcart__x" aria-label="Close cart" data-qc-close>&times;</button></div><div class="qcart__body" id="qcbody"></div><div class="qcart__foot" id="qcfoot"></div></div>';
    document.body.appendChild(panel);
    panel.addEventListener("click", function (e) {
      if (e.target === panel || e.target.closest("[data-qc-close]")) { close(); return; }
      var r = e.target.closest("[data-qc-remove]"); if (r) { remove(r.getAttribute("data-qc-remove")); return; }
      if (e.target.closest("[data-qc-checkout]")) checkout();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !panel.hidden) close(); });
  }

  function render(cart) {
    var body = document.getElementById("qcbody"), foot = document.getElementById("qcfoot");
    if (!cart.items.length) {
      body.innerHTML = '<p class="qcart__empty">Your cart is empty.</p>';
      foot.innerHTML = '<div class="qcart__cta"><button type="button" class="cta ghost" data-qc-close>Back to your result</button></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.name : "";
      var price = it.final_line_price === 0 ? "Free" : money(cart.currency, it.final_line_price);
      return '<div class="qcart__line">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" width="56" height="56">' : '<span class="qcart__ph"></span>') +
        '<div class="qcart__info"><b>' + esc(it.product_title) + '</b>' + (plan ? "<small>" + esc(plan) + "</small>" : "") + "<small>Qty " + it.quantity + "</small></div>" +
        '<div class="qcart__price">' + price + '<button type="button" class="qcart__rm" data-qc-remove="' + esc(it.key) + '">Remove</button></div></div>';
    }).join("");
    var em = quizEmail();
    foot.innerHTML =
      '<div class="qcart__scroll" id="qcscroll">' +
        (cart.total_price > 0 ? '<div class="qcart__row"><span>Subtotal</span><b>' + money(cart.currency, cart.total_price) + "</b></div>" : "") +
        '<div class="qcart__wallets" id="qcwallets" hidden><p class="qcart__label">Express checkout</p><div id="qcwalletbox"></div></div>' +
        (em ? '<p class="qcart__email">Use <b>' + esc(em) + "</b> at checkout. Your Day 0 sheet and coach access are emailed there straight after checkout.</p>" : '<p class="qcart__note">Your Day 0 sheet and coach access are emailed straight after checkout.</p>') +
        '<p class="qcart__note">Shipping and taxes are calculated at checkout.</p>' +
      "</div>" +
      '<div class="qcart__cta"><button type="button" class="cta" data-qc-checkout>Continue to checkout</button></div>';
    loadWallets(0);
  }

  /* Re-sort Shopify's wallet list so the buttons render in WALLET_ORDER */
  function orderWallets(wrap) {
    try {
      var el = wrap.querySelector("shopify-accelerated-checkout-cart"), cfg = JSON.parse(el.getAttribute("wallet-configs"));
      var rank = function (c) { var i = WALLET_ORDER.indexOf(c.name); return i < 0 ? 99 : i; };
      cfg = cfg.map(function (c, i) { return { c: c, i: i }; }).sort(function (a, b) { return (rank(a.c) - rank(b.c)) || (a.i - b.i); }).map(function (x) { return x.c; });
      el.setAttribute("wallet-configs", JSON.stringify(cfg));
    } catch (e) {}
  }

  /* Express checkout buttons, copied from the theme's cart-drawer section HTML */
  function loadWallets(attempt) {
    var holder = document.getElementById("qcwallets"), box = document.getElementById("qcwalletbox");
    if (!holder || !box) return;
    fetch(root() + "?sections=cart-drawer&t=" + Date.now(), { cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j["cart-drawer"] || "", "text/html");
        var wrap = doc.querySelector(".cart__dynamic-checkout-buttons");
        if (!wrap || !wrap.querySelector("shopify-accelerated-checkout-cart")) { if (attempt < 1) setTimeout(function () { loadWallets(attempt + 1); }, 1200); return; }
        orderWallets(wrap);
        box.innerHTML = wrap.innerHTML; holder.hidden = false;
        ev("quiz_wallets_shown");
        setTimeout(function () {
          if (!customElements.get("shopify-accelerated-checkout-cart") && !walletScript) {
            walletScript = true;
            var s = document.createElement("script"); s.src = root() + "cdn/shopifycloud/portable-wallets/latest/portable-wallets.en.js"; document.head.appendChild(s);
          }
        }, 1500);
      })
      .catch(function () {});
  }

  function open() {
    if (!panel) build();
    fit();
    lastFocus = document.activeElement;
    return fetch(root() + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
      render(cart); panel.hidden = false; document.body.style.overflow = "hidden"; fit();
      ev("quiz_cart_view", { items: cart.item_count });
      var b = panel.querySelector("[data-qc-checkout]") || panel.querySelector("[data-qc-close]"); if (b) b.focus({ preventScroll: true });
    }).catch(function () { checkout(); });
  }
  function close() { if (!panel) return; panel.hidden = true; document.body.style.overflow = ""; try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {} }
  function remove(key) {
    fetch(root() + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: 0 }) })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  function checkout() {
    ev("quiz_checkout_click");
    var u = root() + "checkout", e = quizEmail();
    if (e) u += "?checkout[email]=" + encodeURIComponent(e);
    location.href = u;
  }
  window.UmQuizCart = { open: open, close: close };
})();